/** @format */

import { HeaderComponent } from './header/header.component';
import { TimesheetComponent } from './timesheet/timesheet.component';
import { YearAtAGlanceComponent } from './year-at-a-glance/year-at-a-glance.component';
import { AccessDenidedComponent } from './accessdenied/accessdenied.component';
import { ProfilePageComponent } from './profile-page/profile-page.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ApprovalsComponent } from './approvals/approvals.component';
import { PostingsComponent } from './postings/postings.component';
import { ScheduledActingComponent } from './scheduled-acting/scheduled-acting.component';
import { DelegationsComponent } from './delegations/delegations.component';
import { TeamProfilesComponent } from './team-profiles/team-profiles.component';
import { AccountsPanel } from './accounts/accounts-panel.component';

export const containers: any[] = [
	HeaderComponent,
	TimesheetComponent,
	YearAtAGlanceComponent,
	AccessDenidedComponent,
	ProfilePageComponent,
	NotificationsComponent,
	ApprovalsComponent,
	ScheduledActingComponent,
	PostingsComponent,
	DelegationsComponent,
	TeamProfilesComponent,
	AccountsPanel,
];

export * from './header/header.component';
export * from './timesheet/timesheet.component';
export * from './year-at-a-glance/year-at-a-glance.component';
export * from './accessdenied/accessdenied.component';
export * from './profile-page/profile-page.component';
export * from './notifications/notifications.component';
export * from './approvals/approvals.component';
export * from './scheduled-acting/scheduled-acting.component';
export * from './postings/postings.component';
export * from './delegations/delegations.component';
export * from './team-profiles/team-profiles.component';
export * from './accounts/accounts-panel.component';
